"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_KEYS = exports.DATA_ROOM_FEATURE = void 0;
exports.DATA_ROOM_FEATURE = {
    allowInviteGuest: 'allowInviteGuest',
    allowEnableGuestAccess: 'allowEnableGuestAccess',
};
exports.FEATURE_KEYS = Object.keys(exports.DATA_ROOM_FEATURE);
